<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T14:52:33+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Template for other pages than the Landing page
@Last modified by:   tom
@Last modified time: 2019-06-07T14:06:36+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:

<accordion
  id="my-services"
  :rows="7"
  labelkey="solutions.details"
  variant="success" />

- labelkey should point to groups of labels, such as :
- id is require for multiple accordions
- visible set fault to not open first panel when entering page

service:
  details:
    1 :
      icon: 'heart'
      label: 'web account'
      title: 'Configure your Puck'
      slot: 'With at least one each Puck [..].'
      link:
        href: '/prices/puck'
        text: 'Check our prices'
      block: 'Web account for the one-time setup for each Puck'
      img_: 'setup.png'
    2 :
      label: 'alert tokens'
      slot: 'In principle each time you touch Puck, you [,,,].'
      block: 'Fair use policy, so do not let kids play piano on your Pucks please.'

# Note that "label" is required

-->

<template>
  <div role="tablist" class="accordion">

    <div
      v-for="f in rows"
      :key="f">
      <b-card
        v-if="$te(`${labelkey}.${f}.label`)"
        no-body>

        <b-btn
          v-b-toggle="`${id}-accordion-${f}`"
          :variant="variant"
          block
          header-tag="header"
          role="tab"
          href="#"
          class="text-left">
          <icon v-if="$te(`${labelkey}.${f}._icon`, 'en')" :name="$t(`${labelkey}.${f}._icon`)" class="text-primary mr-2" scale="1"/>
          {{ $t(`${labelkey}.${f}.label`) }}
          <span
            v-if="$te(`${labelkey}.${f}.right_label`, 'en')"
            class="right-label"
            v-html="$t(`${labelkey}.${f}.right_label`)"/>
        </b-btn>
        <!-- </b-card-header> -->
        <b-collapse
          :id="`${id}-accordion-${f}`"
          :visible="visible"
          accordion="my-${id}-accordion"
          role="tabpanel"
          @shown="emitScroll(f)">
          <!-- :visible="f===1" -->
          <b-card-body>
            <b-row class="mb-2">
              <b-col v-if="$te(`${labelkey}.${f}._img`, 'en')" md="3">
                <!-- possible ._img if we have label in the lang file -->
                <lzimg :src="imgfolder + $t(`${labelkey}.${f}._img`)"
                       zoom-modal
                       fluid
                       width="500"
                       height="275"/>
              </b-col>
              <b-col>
                <h2 v-if="$te(`${labelkey}.${f}.title`,'en')" class="text-secondary" v-html="$t(`${labelkey}.${f}.title`)"/>

                <div v-if="$te(`${labelkey}.${f}.block`, 'en')">
                  <i v-html="$t(`${labelkey}.${f}.block`)" />
                </div>
              </b-col>
            </b-row>
            <p class="card-text">
              <span v-html="$t(`${labelkey}.${f}.slot`)"/>
              <!-- possible .link -->
              <router-link
                v-if="$te(`${labelkey}.${f}.link._href`,'en')"
                :to="$t(`${labelkey}.${f}.link._href`)"
                v-html="$t(`${labelkey}.${f}.link.text`)"/>
            </p>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div> <!-- v-for -->
  </div>
</template>

<script>
import invokeScrollEvent from '@/components/_shared/invokeScrollEvent'

export default {
  props: {
    id: { type: String, default: '' },
    labelkey: { type: String, default: '' },
    variant: { type: String, default: 'white' },
    rows: { type: Number, default: 10 },
    visible: { type: Boolean, default: true },
    imgfolder: { type: String, default: '' }
  },
  data () {
    return {
      accordionsScrolled: []
    }
  },
  methods: {
    emitScroll (f) {
      if (!this.accordionsScrolled.includes(f)) {
        // for each accordion tab, scroll only once
        invokeScrollEvent(`Accordion ${this.id} ${f}`, 200)
        this.accordionsScrolled.push(f)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .accordion {
    .right-label {
      float: right;
    }
  }

</style>
